<script lang="ts">import Accordion from '../Accordion/Accordion.svelte';
import Section from '../Section/Section.svelte';
import Text from '../Typography/Text/Text.svelte';
export let colorMode = 'light';
export let headingText = '';
export let isFirstItemOpen = false;
export let onClick = () => { };
export let items = [];
</script>

<Section {...$$restProps} class="Faq {$$restProps.class || ''}" {colorMode} {headingText} variant="secondary">
  <Accordion isFirstItemOpenByDefault={isFirstItemOpen} {onClick} {items}>
    <!-- https://svelte.dev/docs/svelte/legacy-svelte-fragment -->
    <!-- Use a svelte:fragment as a pass through slot to avoid wrapping the content in another DOM element -->
    <svelte:fragment slot="summary" let:question>
      <Text as="h3" variant="200" isBalanced={true}>
        {question}
      </Text>
    </svelte:fragment>
    <svelte:fragment slot="content" let:answer>
      <slot name="content" {answer} />
    </svelte:fragment>
  </Accordion>
</Section>

<style>:global(.Faq) :global(.AccordionItem__content) {
  max-width: var(--faq-accordion-item-max-width);
  padding-bottom: var(--faq-accordion-item-content-padding-bottom);
}
:global(.Faq) :global(.AccordionItem__content) :global(p) {
  --max-width: none;
}
:global(.Faq) :global(.AccordionItem__content) :global(a:not(.Action)) {
  font-weight: var(--text-font-weight-regular);
}</style>
